import { Actionsheet as NbActionsheet } from 'native-base';

import { addWithConfig } from '../../utils';

export const Actionsheet = NbActionsheet;

export default addWithConfig(Actionsheet);
